import approvalStatuses from "./constants/approvalStatuses";

export default function isPendingApproval(data) {
	return data?.approval?.status === approvalStatuses.PENDING;
}
